import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const ProtectedRoutes = ({ children }) => {
  let adminToken = localStorage.getItem("sorise-token-admin");
  const location = useLocation();

  if (!adminToken || adminToken.split(".").length < 3) {
    Swal.fire({
      icon: "warning",
      title: "Token Expired!",
      text: "Please Login again",
      showConfirmButton: true,
      timer: false,
      confirmButtonColor: "rgb(4 98 176)",
    });
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoutes;
